import { useState } from "react";
import {
  withApi,
  withNotifier,
  withBrowser,
  apiShape,
  notifierShape,
  browserShape,
} from "../../context";
import { withUser, withFlipper, withIntl } from "../../wrappers";
import SwitchInput from "../Form/SwitchInput";
import MenuItemAddon from "./MenuItemAddon";
import { intlShape, userShape } from "../../shapes";
import CONFIGURATION from "../../configuration";

type Props = {
  api: apiShape;
  notifier: notifierShape;
  intl: intlShape;
  user: userShape;
  browser: browserShape;
  flipper: {
    demoDataActive?: boolean;
  };
};

export function NavigationDemoData({
  api,
  notifier,
  intl,
  flipper,
  browser,
  user,
}: Props) {
  const [activated, setActivation] = useState(user.demoDataActive);
  const [switchDisabled, setSwitchDisabled] = useState(false);

  if (!flipper.demoDataActive) return null;

  const saveDemoDataActivationState = async () => {
    setSwitchDisabled(true);
    try {
      if (activated) {
        await api.delete("/users/current/demo_data");
        notifier.showSuccess(
          intl.formatMessage({
            id: "navigation.demo_data_deactivation_success_notification",
          }),
        );
      } else {
        await api.post("/users/current/demo_data");
        notifier.showSuccess(
          intl.formatMessage({
            id: "navigation.demo_data_activation_success_notification",
          }),
        );
      }
      setActivation((prev) => !prev);
      setTimeout(() => {
        browser.redirectToExtern(`${CONFIGURATION.BASE_URL}`);
      }, 2000);
    } catch (apiErrors) {
      notifier.showError(api.translateError(apiErrors));
    }
  };

  return (
    <MenuItemAddon className="navigation-demo-data">
      <p>{intl.formatMessage({ id: "navigation.demo_data" })}</p>
      <SwitchInput
        // @ts-expect-error TS(2322) FIXME: Type '{ className: string; id: string; name: strin... Remove this comment to see the full error message
        className="navigation-demo-data-button"
        id="navigation-demo-data"
        name="navigation-demo-data"
        values={{ "navigation-demo-data": activated }}
        handleChange={saveDemoDataActivationState}
        disabled={switchDisabled}
        hideLabel
        smallButton
      />
    </MenuItemAddon>
  );
}

export default withBrowser(
  withNotifier(withFlipper(withApi(withIntl(withUser(NavigationDemoData))))),
);
